import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { superAxiosRequest } from 'axiosApi'
import modalStore from 'Stores/modalStore'
import { dateFormat } from 'helpers/date'
import { checkHolyDays } from './CreateTimeTable'
import { classNames as cn } from 'helpers'
import DayTeacherClassroomSelector from './DayTeacherClassroomSelector'
import DayTooltip from './DayTooltip'
import st from './Days.module.scss'

function arraysEqualNumbers(arr1, arr2) {
  if (!arr1?.length || !arr2?.length) return false
  if (arr1.length !== arr2.length) return false
  const sortedArr1 = arr1?.sort((a, b) => a - b)
  const sortedArr2 = arr2?.sort((a, b) => a - b)
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return false
  }
  return true
}
function arraysEqual(arr1, arr2) {
  if (!arr1?.length || !arr2?.length) return false
  if (arr1.length !== arr2.length) return false

  const sortedArr1 = arr1.slice().sort()
  const sortedArr2 = arr2.slice().sort()
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return false
  }
  return true
}

const createCalendar = (
  date_from,
  date_until,
  weekdays,
  holidays,
  availableList,
) => {
  const days = []
  let startAt = new Date(`${date_from}T12:00:00`)
  const endAt = new Date(`${date_until}T12:00:00`)

  let ssDate

  while (startAt <= endAt) {
    const dow = startAt.getDay() || 7

    if (weekdays.includes(dow)) {
      ssDate = dateFormat(startAt, 'YYYY-mm-dd')

      days.push({
        date: new Date(startAt),
        sDate: dateFormat(startAt, 'dd.mm.YY'),
        ssDate,
        is_holiday: checkHolyDays(ssDate, holidays),
        is_teacher_available: availableList.find((d) => d.date === ssDate)
          ?.teachers[0].is_available,
        is_class_available: availableList.find((d) => d.date === ssDate)
          ?.is_class_available,
      })
    }
    startAt = new Date(startAt.setDate(startAt.getDate() + 1))
  }

  return days
}

const Days = (props) => {
  const {
    data: {
      payload: { holidays },
    },
    modalValues,
  } = modalStore
  const { date_from, date_until, weekdays } = modalValues

  const [days, setDays] = useState([])
  const [oldParams, setOldParams] = useState({})
  const [availableList, setAvailableList] = useState({
    key: '',
    dates: [],
  })
  const [selectedDay, setSelectedDay] = useState(null)
  const [tooltip, setTooltip] = useState({
    open: false,
    idx: null,
    target: null,
  })

  const refsDays = []

  const handleMouseEnter = (idx) => {
    setTooltip({ open: true, idx, target: refsDays[idx] })
  }

  const handleMouseOut = () => {
    setTooltip({ open: false, idx: null, target: null })
  }

  useEffect(() => {
    const arr = createCalendar(
      date_from,
      date_until,
      weekdays,
      holidays,
      availableList.dates,
    )

    setDays(arr)
    const newDays = arr.map((d) => d.ssDate)

    if (!arraysEqual(newDays, props?.oldDays)) {
      props.onChange(newDays)
    }
  }, [date_from, date_until, weekdays, availableList.dates])

  useEffect(() => {
    const realFinishAtModalValues =
      modalValues?.finish_at?.length === 5
        ? `${modalValues?.finish_at}:00`
        : modalValues?.finish_at
    if (
      oldParams?.group_id === modalValues.group_id &&
      oldParams?.start_at === modalValues.start_at &&
      oldParams?.finish_at === realFinishAtModalValues &&
      oldParams?.classroom_id === modalValues.classroom_id &&
      arraysEqualNumbers(oldParams?.teachers, modalValues.teachers)
    ) {
      return
    }
    const params = {
      group_id: modalValues.group_id,
      start_at: modalValues.start_at,
      finish_at: modalValues.finish_at,
      dates: days.map((d) => d.ssDate),
      teachers: modalValues.teachers,
      classroom_id: modalValues.classroom_id,
    }

    setOldParams(params)

    const key = JSON.stringify(params)

    if (
      modalValues.teachers.length === 0 ||
      !modalValues.classroom_id ||
      key === availableList.key
    )
      return
    superAxiosRequest(
      {
        method: 'post',
        link: 'schedule/workshop_check_teachers_and_class',
      },
      params,
    )
      .then((res) => {
        setAvailableList({ key, dates: res.data.dates })
      })
      .catch(() => {})
  }, [days, modalValues.classroom_id, modalValues.teachers])

  return (
    <div>
      <div className={st.days}>
        {days.map((d, idx) => (
          <div key={d.sDate}>
            <div
              className={cn({
                [st.day]: true,
                [st.day__holiday]: d.is_holiday,
                [st.day__teacher]:
                  d.is_teacher_available === false && !d.is_holiday,
                [st.day__classroom]:
                  d.is_class_available === false && !d.is_holiday,
              })}
              onClick={() => setSelectedDay(d.is_holiday ? null : d.date)}
              onMouseOver={() => handleMouseEnter(idx)}
              onMouseLeave={handleMouseOut}
              ref={(ref) => (refsDays[idx] = ref)}
            >
              <span>{d.sDate}</span>
              {tooltip.open && tooltip.idx === idx && (
                <DayTooltip
                  date={d.date}
                  teachers={props.teachers}
                  classrooms={props.classrooms}
                  target={tooltip.target}
                />
              )}
            </div>
          </div>
        ))}
      </div>
      {selectedDay && <DayTeacherClassroomSelector date={selectedDay} />}
    </div>
  )
}

export default observer(Days)
